!(function () {
  "use strict";
  customElements.get("quantity-counter") ||
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        constructor() {
          super();
          this.btn_name = null;
        }
        connectedCallback() {
          (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.buttonClickEvent = this.onButtonClick.bind(this)),
            (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
            (this.onQuantityBlurEvent = this.onQuantityBlur.bind(this)),
            this.input.addEventListener("change", this.onQuantityChangeEvent),
            this.input.addEventListener("blur", this.onQuantityBlurEvent),
            this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.buttonClickEvent));

          calcBaseFeaturePrice(this.input.value, this.input.dataset.key);
        }
        onButtonClick(t) {
          t.preventDefault();
          const e = this.input.value,
            n = "BUTTON" == t.target.nodeName ? t.target : t.target.closest("button");
          if (n.name === "increase") {
            this.btn_name = "increase";
            let max_value = isNaN(parseFloat(this.input.max)) || parseFloat(this.input.max) === 0 ? 999999 : parseFloat(this.input.max);
            if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {

              let new_mts = (((parseFloat(this.input.dataset.propertieTelaMts) * 100) + 50) / 100);

              this.input.setAttribute("data-propertie-tela-mts", (new_mts).toFixed(2));
              if (this.input.name === "properties[Metros]") {
                this.input.value = this.input.dataset.propertieTelaMts;
              }
              if (this.input.dataset.policy === 'false' && parseFloat(this.input.value) > parseFloat(this.input.dataset.stockMts)) {
                document.querySelector('.wim-prev-add-to-cart').classList.remove('d-none');
              }
              else {
                document.querySelector('.wim-prev-add-to-cart').classList.add('d-none');
                document.querySelector('.product__submit__item--error-message-stock-mts').classList.add('d-none');
              }
            }
            else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

              let new_mts = (((parseFloat(this.input.dataset.propertieMts) * 100) + 50) / 100);
              this.input.setAttribute("data-propertie-mts", (new_mts >= max_value ? max_value : new_mts).toFixed(2));
              this.input.value = this.input.dataset.propertieMts;
            }
            if (this.input.name != "properties[Metros]" && this.input.dataset.customProduct != "true") {
              this.input.stepUp();
            }
          }
          if (n.name === "decrease") {
            let min_value = isNaN(parseFloat(this.input.min)) ? 0 : parseFloat(this.input.min);
            this.btn_name = "decrease";
            if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {

              let new_mts = (((parseFloat(this.input.dataset.propertieTelaMts) * 100) - 50) / 100);

              this.input.setAttribute("data-propertie-tela-mts", (new_mts <= min_value ? min_value : new_mts).toFixed(2));
              if (this.input.name === "properties[Metros]") {
                this.input.value = this.input.dataset.propertieTelaMts;
              }
              if (this.input.dataset.policy === 'false' && parseFloat(this.input.value) > parseFloat(this.input.dataset.stockMts)) {
                document.querySelector('.wim-prev-add-to-cart').classList.remove('d-none');
              }
              else {
                document.querySelector('.wim-prev-add-to-cart').classList.add('d-none');
                document.querySelector('.product__submit__item--error-message-stock-mts').classList.add('d-none');
              }
            }
            else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

              let new_mts = (((parseFloat(this.input.dataset.propertieMts) * 100) - 50) / 100);

              this.input.setAttribute("data-propertie-mts", (new_mts <= min_value ? min_value : new_mts).toFixed(2));
              this.input.value = this.input.dataset.propertieMts;
            }
            if (this.input.name != "properties[Metros]" && this.input.dataset.customProduct != "true") {
              this.input.stepDown();
            }
          }
          if (e !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        }
        onQuantityChange() {
          if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {

            if (parseFloat(this.input.value) != this.input.dataset.propertieTelaMts && parseFloat(this.input.value) > parseFloat(this.input.min)) {

              this.input.setAttribute("data-propertie-tela-mts", parseFloat(this.input.value).toFixed(2));
            }
            if (this.input.name === "properties[Metros]") {
              let value = parseFloat(this.input.value);
              let min_value = isNaN(parseFloat(this.input.min)) ? 0 : parseFloat(this.input.min);
              if (isNaN(value) || value < min_value) {
                this.input.value = min_value.toFixed(2);
              } else if (value >= min_value) {
                this.input.value = ((value * 100).toFixed(2) / 100).toFixed(2);
              }
              if (this.input.dataset.policy === 'false' && parseFloat(this.input.value) > parseFloat(this.input.dataset.stockMts)) {
                document.querySelector('.wim-prev-add-to-cart').classList.remove('d-none');
              }
              else {
                document.querySelector('.wim-prev-add-to-cart').classList.add('d-none');
                document.querySelector('.product__submit__item--error-message-stock-mts').classList.add('d-none');
              }
              this.input.setAttribute("data-propertie-tela-mts", parseFloat(this.input.value).toFixed(2));
              this.querySelector("input[name='quantity']").value = 1;
            }
          }
          else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

            let value = parseFloat(this.input.value);
            if (isNaN(value) || value < parseFloat(this.input.min)) {
              this.input.value = ((parseFloat(this.input.min) * 100).toFixed(2) / 100).toFixed(2);
            }
            if (parseFloat(this.input.value) != value && !isNaN(parseFloat(this.input.value))) {
              this.input.setAttribute("data-propertie-mts", parseFloat(this.input.value).toFixed(2));
            }
            if (this.input.dataset.type === 'base_features') {
              calcBaseFeaturePrice(this.input.value, this.input.dataset.key);
            }
          }
          if (["updates[]", "cartLine[mts]"].includes(this.input.name)) {
            if (!isNaN(parseFloat(this.input.value))) {
              this.updateCart();
            }
          }
        }
        onQuantityBlur() {
          if (this.input.dataset.esTela && this.input.dataset.esTela === "true") {
            let value = parseFloat(this.input.value);
            let min_value = isNaN(parseFloat(this.input.min)) ? 0 : parseFloat(this.input.min);
            if (isNaN(value) || value < min_value) {
              this.input.value = min_value.toFixed(2);
            }
            else {
              this.input.value = ((parseFloat(this.input.value) * 100).toFixed(2) / 100).toFixed(2);
              if (this.input.dataset.policy === 'false' && parseFloat(this.input.value) > parseFloat(this.input.dataset.stockMts)) {
                document.querySelector('.wim-prev-add-to-cart').classList.remove('d-none');
              }
              else {
                document.querySelector('.wim-prev-add-to-cart').classList.add('d-none');
                document.querySelector('.product__submit__item--error-message-stock-mts').classList.add('d-none');
              }
            }
            if (this.input.name === "properties[Metros]") {
              this.querySelector("input[name='quantity']").value = 1;
            }
            if (parseFloat(this.input.value) != value && !isNaN(parseFloat(this.input.value))) {
              this.input.setAttribute("data-propertie-tela-mts", parseFloat(this.input.value).toFixed(2));
              this.updateCart();
            }
          }
          else if (this.input.dataset.customProduct && this.input.dataset.customProduct === "true") {

            let value = parseFloat(this.input.value);

            if (isNaN(value) || value < parseFloat(this.input.min)) {
              this.input.value = ((parseFloat(this.input.min) * 100).toFixed(2) / 100).toFixed(2);
            }
            if (this.input.dataset.type === 'base_features') {
              calcBaseFeaturePrice(this.input.value, this.input.dataset.key);
            }
            if (parseFloat(this.input.value) != value && !isNaN(parseFloat(this.input.value))) {
              this.input.setAttribute("data-propertie-mts", parseFloat(this.input.value).toFixed(2));
              this.updateCart();
            }
          }
        }
        updateCart() {
          if ("" !== this.quantityValue) {
            this.dispatchEvent(new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: {
                properties: {
                  Metros: this.input.dataset.propertieTelaMts,
                  stock_mts: this.input.dataset.stockMts,
                  inv: this.input.dataset.policy
                },
                button: this.btn_name,
                id: this.input.dataset.id,
                quantity: this.input.dataset.esTela && this.input.dataset.esTela === "true" ? 1 : this.input.value
              }
            }))
          };
        }
      }
    );
})();

function calcBaseFeaturePrice(input_value, feature_key) {
  let data_calculate_scale_price = document.querySelector(`input[name='calculate_scale_${feature_key}']`);
  if (data_calculate_scale_price) {
    let calculate_scale_type = data_calculate_scale_price.dataset.calculate;
    let price_base = parseFloat(document.querySelector('[data-custom-product-price]').dataset.customProductPrice) / 100;
    let add_price = 0;
    if (calculate_scale_type === 'single-price-scale') {
      let single_price_scale = window.custom_product.base_features[feature_key.replace('base_feature_', '')]?.value || null;
      let num_aplay_scale = parseFloat(input_value) > parseFloat(single_price_scale.min_quantity) ? 1 : 0;
      num_aplay_scale += (parseFloat(input_value) - parseFloat(single_price_scale.min_quantity)) / parseFloat(single_price_scale.scale);

      if (single_price_scale.price_modifier_type === 'percentage') {
        let total_percentage = (num_aplay_scale * single_price_scale.price_modifier_value) / 100;
        add_price = price_base * total_percentage;
      }
      else {
        add_price = (num_aplay_scale * single_price_scale.price_modifier_value);
      }
    }
    else if (calculate_scale_type === 'table-price') {

      let table_item = (window.custom_product.base_features[feature_key.replace('base_feature_', '')]?.value?.items || []).reduce((previous_item, current_item) => {
        previous_item = parseFloat(input_value) >= current_item.min_quantity ? current_item : previous_item;
        return previous_item;
      }, null);
      if (table_item) {
        if (table_item.price_modifier_type === 'percentage') {
          add_price = price_base * (table_item.price_modifier_value / 100);
        }
        else {
          add_price = table_item.price_modifier_value;
        }
      }
    }
    data_calculate_scale_price.setAttribute("data-add-price", add_price);
    calcCustomProductPrice();
  }
};
function calcAdditionalFeaturePrice(selected_value, feature_key, feature_field = 'drop-down', feature_handle = '') {
  let data_additional_feature = document.querySelector(`input[name="list-options_${feature_key}"]`);
  let list_options = window.custom_product.additional_features[feature_key.replace('additional_feature_', '')]?.options || [];
  let add_price = 0;
  let price_base = 0;
  let select_option = null;
  if (data_additional_feature) {

    data_additional_feature.closest('.wim-additional-feature').querySelector('.selected-option').textContent = selected_value;
    if (feature_field === 'input-text' && selected_value !== "" && ![null, "null"].includes(selected_value)) {

      select_option = list_options.find(item => item.handle === feature_handle);
    }
    else {

      select_option = list_options.find(item => Object.keys(item.name).some(key => item.name[key] === selected_value));
    }
    if (select_option) {
      let base_feature_prices = document.querySelectorAll('input[type="hidden"][data-type="base_features"]');
      if (select_option.price_modifier_type === 'percentage') {
        if (base_feature_prices) {
          price_base = Array.from(base_feature_prices).reduce((previous_item, current_item) => {
            previous_item += parseFloat(current_item.dataset.addPrice) || 0;
            return previous_item;
          }, 0);
        }
        price_base += (parseFloat(document.querySelector('[data-custom-product-price]').dataset.customProductPrice) / 100);
        add_price = price_base * (select_option.price_modifier_value / 100);
      }
      else {
        add_price = select_option.price_modifier_value;
      }
      data_additional_feature.setAttribute("data-propertie-value", selected_value);
    }
    else {
      data_additional_feature.setAttribute("data-propertie-value", "");
    }
    data_additional_feature.setAttribute("data-add-price", add_price);
    calcCustomProductPrice();
  }
};
function calcCustomProductPrice() {

  let list_base_feature_prices = document.querySelectorAll('input[type="hidden"][data-type="base_features"]');
  let list_additional_feature_prices = document.querySelectorAll('input[type="hidden"][data-type="additional_features"]');
  let base_feature_price = 0;
  let additional_feature_price = 0;
  let count_features = 0;
  if (list_base_feature_prices) {
    base_feature_price = Array.from(list_base_feature_prices).reduce((previous_item, current_item) => {
      previous_item += parseFloat(current_item.dataset.addPrice) || 0;
      count_features += 1;
      return previous_item;
    }, 0);
  }
  if (list_additional_feature_prices) {
    let list_features = [];
    let count_additional_features = 0;
    additional_feature_price = Array.from(list_additional_feature_prices).reduce((previous_item, current_item) => {
      previous_item += parseFloat(current_item.dataset.addPrice) || 0;
      count_features += 1;
      count_additional_features += 1;
      if (current_item.dataset.field != 'input-text') {
        if (current_item.dataset.propertieValue && current_item.dataset.propertieValue !== "") {
          list_features.push(`${current_item.dataset.propertieKey}: ${current_item.dataset.propertieValue}`);
        }
      }
      else if (current_item.dataset.field === 'input-text') {

        let input_fields = document.querySelectorAll(`input[type="text"][data-type="additional_features"][data-key="${current_item.dataset.key}"]`);
        if (input_fields) {
          let input_values = Array.from(input_fields).reduce((previous_value, current_value) => {
            if (current_value.value && !["", null, "null"].includes(current_value.value)) {
              previous_value.push(current_value.value);
            }
            return previous_value;
          }, []);
          if (input_values.length > 0) {
            list_features.push(`${current_item.dataset.propertieKey}: ${input_values.join(' - ')}`);
          }
        }
      }
      return previous_item;
    }, 0);
    if (list_features.length == count_additional_features) {

      document.querySelector('input[name="properties[Caracteristicas]"]').value = list_features.join(', ');
    }
  }
  let product_price = document.querySelector('[data-custom-product-price]');
  if (product_price) {
    const formatterCurrency = new Intl.NumberFormat(product_price.dataset.customProductLocale, { style: 'currency', currency: product_price.dataset.customProductCurrency, minimumFractionDigits: 2 });

    let amount_format = formatterCurrency.format(((parseFloat(product_price.dataset.customProductPrice) || 0) / 100) + base_feature_price + additional_feature_price);
    product_price.textContent = amount_format;
    // product_price.textContent = `${ product_price.dataset.customProductCurrencyCode }${ amount_format.replace(/[^\d.,-]/g, '').trim() }`;
    product_price.classList.remove('d-none');
  }
  let error_features = [];
  let count_base_features = Array.from(list_base_feature_prices).filter(item => !["", null, "null"].includes(item.dataset.propertieValue)).length;
  let count_additional_features = Array.from(list_additional_feature_prices).filter(item => {
    if (item.dataset.field === 'input-text') {
      return true;
    }
    else {
      if (["", null, "null"].includes(item.dataset.propertieValue) && window.custom_product.additional_features[item.dataset.key.replace('additional_feature_', '')]) {
        error_features.push(window.custom_product.additional_features[item.dataset.key.replace('additional_feature_', '')]?.title);
      }
      return !["", null, "null"].includes(item.dataset.propertieValue)
    }
  }).length;
  if (count_base_features + count_additional_features === count_features) {

    document.querySelectorAll('.hidden-buy-buttons').forEach((item) => {
      item.classList.add('disabled');
    });
  }
  else {
    document.querySelectorAll('.hidden-buy-buttons').forEach((item) => {
      item.classList.remove('disabled');
    });
  }
  document.querySelector('.wim-product-custom__error-message-features').classList.add('d-none');
  if (error_features.length > 0) {
    document.querySelector('.wim-product-custom__error-message-features .features-required-list').innerHTML = `${error_features.join(', ')}.`;
    document.querySelector('.wim-product-custom__error-message-features').classList.remove('d-none');
  }
};
document.addEventListener("DOMContentLoaded", () => {

  let additional_feature_drop_downs = document.querySelectorAll('select[data-type="additional_features"]');
  let additional_feature_swatchs = document.querySelectorAll('input[type="radio"][data-type="additional_features"]');
  let additional_feature_fields = document.querySelectorAll('input[type="text"][data-type="additional_features"]');
  if (additional_feature_drop_downs) {
    additional_feature_drop_downs.forEach((select) => {
      select.addEventListener('change', (event) => {
        let selected_option = select.options[select.selectedIndex];
        if (selected_option) {
          calcAdditionalFeaturePrice(selected_option.value, select.dataset.key, event.target.dataset.field);
        }
      });
    });
  }
  if (additional_feature_swatchs) {
    let swatchs_by_name = Array.from(additional_feature_swatchs).reduce((previous_item, current_item) => {
      if (!previous_item.includes(current_item.name)) {
        previous_item.push(current_item.name);
      }
      return previous_item;
    }, []);
    if (swatchs_by_name.length > 0) {
      swatchs_by_name.forEach((name) => {
        let swatchs = document.querySelectorAll(`input[type="radio"][data-type="additional_features"][name="${name}"]`);
        if (swatchs) {
          swatchs.forEach((swatch) => {
            swatch.addEventListener('change', (event) => {
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field);
            });
          });
        }
      });
    }
  }
  if (additional_feature_fields) {
    let fields_by_name = Array.from(additional_feature_fields).reduce((previous_item, current_item) => {
      if (!previous_item.includes(current_item.name)) {
        previous_item.push(current_item.name);
      }
      return previous_item;
    }, []);
    if (fields_by_name.length > 0) {
      fields_by_name.forEach((name) => {
        let fields = document.querySelectorAll(`input[type="text"][data-type="additional_features"][name="${name}"]`);
        if (fields) {
          fields.forEach((field) => {
            field.addEventListener('input', (event) => {
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });
            field.addEventListener('change', (event) => {
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });
            field.addEventListener('blur', (event) => {
              event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
              calcAdditionalFeaturePrice(event.target.value, event.target.dataset.key, event.target.dataset.field, event.target.dataset.handle);
            });

          });
        }
      });
    }
  }
  let mts_prev_add_to_cart = document.querySelector('.wim-prev-add-to-cart');
  if (mts_prev_add_to_cart) {
    mts_prev_add_to_cart.addEventListener('click', (event) => {

      let input_mts = document.querySelector('input[name="properties[Metros]"]');
      if (input_mts) {
        document.querySelector('.product__submit__item--error-message-stock-mts').classList.remove('d-none');
        input_mts.value = parseFloat(input_mts.dataset.stockMts).toFixed(2);
        input_mts.setAttribute("data-propertie-tela-mts", parseFloat(input_mts.dataset.stockMts).toFixed(2));
      }
      setTimeout(() => {
        mts_prev_add_to_cart.classList.add('d-none');
      }, 500);
    });
  }
});